import { Directive, ElementRef, forwardRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[brlCurrency]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BrlCurrencyDirective),
      multi: true,
    },
  ],
})
export class BrlCurrencyDirective implements ControlValueAccessor {
  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};
  private disabled = false;

  private formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: number | null): void {
    const inputEl = this.el.nativeElement;
    if (!inputEl) return;

    if (value === null || value === undefined || Number.isNaN(value)) {
      inputEl.value = '';
      return;
    }

    inputEl.value = this.formatter.format(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    const inputEl = this.el.nativeElement;
    if (inputEl) inputEl.disabled = isDisabled;
  }

  @HostListener('input', ['$event'])
  handleInput(event: Event): void {
    if (this.disabled) return;

    const target = event.target as HTMLInputElement | null;
    if (!target) return;

    const raw = target.value || '';
    const digits = raw.replace(/\D/g, '');

    if (!digits) {
      this.onChange(null);
      target.value = '';
      return;
    }

    const value = Number(digits) / 100;
    this.onChange(value);
    target.value = this.formatter.format(value);
  }

  @HostListener('blur')
  handleBlur(): void {
    this.onTouched();
  }
}
